<template>
  <div
    class="tooltip"
    :class="{'tooltip--visible' : isToolTipVisible}"
    @click="dismissTooltip()"
    @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
    @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
  >
    <div class="tooltip__icon">
      <div class="tooltip-symbols-ctn">
        <div v-if="icon === 'forward'" class="forward-icon-animation">
          <span class="icon-ctn forward-icon">
            <i class="fas fa-forward" />
          </span>
          <span class="icon-ctn forward-icon">
            <i class="fas fa-forward" />
          </span>
        </div>
        <div v-else class="drag-icon-animation">
          <div class="translate">
            <span class="icon-ctn drag-icon">
              <span class="drag-icon__preview" />
            </span>
            <span class="icon-ctn drag-icon">
              <span class="drag-icon__preview" />
            </span>
          </div>
          <div class="cursor-icon" />
        </div>
      </div>
    </div>
    <div class="tooltip__message">
      <p class="text-xl">
        {{ title }}
      </p>
      {{ text }}
    </div>
    <div ref="indicator" class="tooltip__indicator" :class="{'tooltip__indicator--visible' : isToolTipVisible}" />
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  data () {
    return {
      timeout: undefined,
      isToolTipVisible: false,
      title: '',
      text: '',
      icon: ''
    }
  },
  methods: {
    dismissTooltip () {
      this.$root.$emit('dismiss-tooltip')
      this.isToolTipVisible = false
      this.$refs.indicator.style.transitionDuration = undefined
    }
  },
  mounted () {
    this.$root.$on('show-tooltip', ({ title, text, time, icon }) => {
      this.title = title
      this.text = text
      this.isToolTipVisible = true
      this.icon = icon
      this.$refs.indicator.style.transitionDuration = `${time}ms`

      this.timeout = setTimeout(() => {
        this.dismissTooltip()
      }, time)
    })
    this.$root.$on('force-dismiss-tooltip', () => {
      this.dismissTooltip()
      clearTimeout(this.timeout)
    })
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.tooltip
  @apply fixed z-50 half-l pin-b flex bg-white border-3 border-black font-sans
  transform: translate(-50%, 100%)
  transition: transform .5s
  width: 93%
  @screen sm-l
    width: initial
  @screen md
    width: initial
  &__icon
    @apply flex items-center justify-center text-3xl border-r-3 border-black h-16
    min-width: 4rem
    width: 4rem
    @screen lg
      @apply h-20
      min-width: 5rem
      width: 5rem
  &__message
    @apply flex flex-col justify-center px-2
  &__indicator
    @apply absolute h-1 bg-black
    width: calc(100% + 6px)
    left: -3px
    top: 112%
    transform-origin: left center
    transform: scaleX(0)
    transition-timing-function: linear
    transition-property: transform
    &--visible
      transform: scaleX(1)
  &--visible
    transform: translate(-50%, -20%)

.tooltip-symbols-ctn
  @apply flex overflow-hidden w-full h-full

.forward-icon-animation
  @apply flex relative w-full h-full
  left: calc(-4rem + 3px)
  @screen lg
    left: calc(-5rem + 3px)

.drag-icon-animation
  @apply relative w-full

.icon-ctn
  @apply flex items-center justify-center min-w-full h-full
  & > *
    @apply relative
    left: 3px

.preview-icon-ctn
  @apply w-full

.forward-icon
  @apply flex relative
  animation: forward-translate 3s infinite

.translate
  @apply flex w-full h-full
  animation: preview-translate 4s infinite

.cursor-icon
  @apply absolute z-10 bg-grey rounded-full w-4 h-4
  box-shadow: 0 0 8px 0 rgba(255, 255, 255, 0.22), 0 0 4px 0 rgba(255, 255, 255, 0.18)
  right: 10px
  bottom: 10px
  animation: cursor-translate 4s infinite

.drag-icon
  @apply flex items-center justify-center
  &__preview
    @apply bg-black rounded w-2/3 h-5/6

@keyframes preview-translate
  0%
    transform: translateX(0)
  20%, 100%
    transform: translateX(-100%)

@keyframes cursor-translate
  0%
    transform: translateX(0)
  20%, 60%
    transform: translateX(-2rem)
  80%, 100%
    transform: translateX(0)

@keyframes forward-translate
  0%
    transform: translateX(0)
  20%, 100%
    transform: translateX(100%)
</style>
